import styled from '@emotion/styled'
import { Calendar } from 'react-date-range'

const SELECTED_DATE_COLOR = '#fff'
const StyledWrapper = styled.div`
  display: flex;
  position: relative;
`
const StyledCalendarWrapper = styled('div')`
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 999;
  border-radius: 4px;
  direction: ltr;
  border: 1px solid #dbdfea;
  box-shadow: none;
  width: 270px;
  color: #c3c6cb;
  background: #fff;
`
const StyledCalendar = styled(Calendar)`
  .rdrMonthAndYearWrapper,
  .rdrWeekDays {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 800;
    font-size: 12px;
  }
  .rdrMonthAndYearWrapper {
    border-bottom: solid 1px #dee0e3;
  }
  .rdrMonthsVertical {
    padding: 10px;
  }
  .rdrWeekDay {
    width: 34px;
    height: 30px;
    padding: 4px;
  }
  .rdrDay {
    position: relative;
    font-size: 14px;
  }
  .rdrDays {
    display: flex;
    flex-wrap: wrap;
    button {
      outline: none;
      background: #fff;
      border: none;
      padding: 0;
      width: 25px;
      height: 24px;
      margin: 0 5px;
      span:hover {
        background: #ebeef2;
        cursor: pointer;
      }
    }
    .rdrDayNumber {
      padding: 4px;
      display: block;
      text-align: center;
      width: 25px;
      border-radius: 4px;
      height: 24px;
      color: #1f2329;
      position: absolute;
      top: 0;
      left: 0;
      line-height: 16px;
    }
    .rdrDayPassive .rdrDayNumber {
      color: #c3c6cb;
    }
  }
  .rdrNextPrevButton {
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 0.833em;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: #fff;
    &:hover {
      background: #ebeef2;
      cursor: pointer;
    }
    i {
      display: block;
      width: 0;
      height: 0;
      padding: 0;
      text-align: center;
      border-style: solid;
      margin: auto;
      transform: translate(-3px, 0px);
    }
  }

  .rdrPprevButton {
    i {
      border-width: 4px 6px 4px 4px;
      border-color: transparent rgb(52, 73, 94) transparent transparent;
      transform: translate(-3px, 0px);
    }
  }

  .rdrNextButton {
    i {
      margin: 0 0 0 7px;
      border-width: 4px 4px 4px 6px;
      border-color: transparent transparent transparent rgb(52, 73, 94);
      transform: translate(3px, 0px);
    }
  }
  .rdrMonthAndYearPickers {
    display: flex;
    font-weight: 600;
    select {
      appearance: none;
      -webkit-appearance: none;
      border: 0;
      background: transparent;
      padding: 10px 30px 10px 10px;
      border-radius: 4px;
      outline: 0;
      color: #3e484f;
      background-position: right 8px center;
      cursor: pointer;
      text-align: center;
    }
  }
  .rdrMonthPicker {
    option {
      -webkit-appearance: none;
      background: #fff;
      cursor: pointer;
    }
  }

  .rdrDayToday span.rdrDayNumber {
    background: ${({ currentDateBackground }) => {
      return currentDateBackground
    }} !important;
    span {
      color: ${({ currentDateColor }) => {
        return currentDateColor
      }};
    }
  }

  .rdrSelected,
  .rdrInRange,
  .rdrStartEdge,
  .rdrEndEdge {
    width: 25px;
    border-radius: 4px;
    height: 24px;
    background: ${({ selectedDateBackground }) => {
      return selectedDateBackground
    }} !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 5px;
  }
  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: ${({ selectedDateColor }) => {
      return selectedDateColor || SELECTED_DATE_COLOR
    }};
  }
`
const StyledSelect = styled.div`
  display: flex;
  .mantine-Select-input {
    color: var(--ow-color-gray-300);
    height: 34px;
    padding: 0 12px;
    width: 55px;
  }
  .mantine-Select-rightSection {
    display: none;
  }
`

export { StyledWrapper, StyledCalendar, StyledSelect, StyledCalendarWrapper }
